import React, { useContext, useEffect, useRef } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import Select from 'react-select'
import { newRegionAdminSchema } from '../../../util/validationSchema'
import { yupResolver } from '@hookform/resolvers/yup'
import { SpinnerContext } from '../../../context/spinnerContext'
import { errorToast, successToast } from '../../../util/Toast/toast'
import { addRegionalAdmin } from '../../../redux/slices/adminControlSlice'

const NewRegionAdmin = ({ toggle, setIsRefresh, regionID }) => {
  const selectRef = useRef()
  const { allAdmin } = useSelector(({ adminControl }) => adminControl)
  const { allRegion } = useSelector(({ region }) => region)
  const dispatch = useDispatch()
  const { changeLoader } = useContext(SpinnerContext)
  const defaultRegion = regionID ? allRegion.find((region) => region.region_id === regionID) : null

  const {
    handleSubmit,
    control,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(newRegionAdminSchema),
    defaultValues: regionID
      ? {
          admin_id: null,
          region: defaultRegion ? { region_id: defaultRegion.region_id, region: defaultRegion.region } : null
          // regions: [regionID] // Directly use regionID in an array
        }
      : { admin_id: null, regions: null } // Set the default values here
  })

  const onSubmit = (data) => {
    setIsRefresh(false)
    const payload = {
      region_id: data?.region?.region_id,
      admin_id: data?.admin_id?.admin_id
    }
    dispatch(addRegionalAdmin(payload))
      .then(({ payload, error }) => {
        if (payload?.status === 200) {
          toggle()
          changeLoader(false)
          setIsRefresh(true)
          successToast(payload?.data?.status_message || 'Success!')
        } else {
          errorToast(payload?.data?.status_message || error?.message)
          changeLoader(false)
        }
      })
      .catch(() => {
        changeLoader(false)
      })
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      if (selectRef.current) {
        selectRef.current.focus()
      }
    }, 0)

    return () => clearTimeout(timer)
  }, [])

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="row">
        <div className="col-lg-12 col-sm-12">
          <div className="form-group input_text">
            <label>
              Admin
              <span className="text-danger"> *</span>
            </label>
            <Controller
              name="admin_id"
              control={control}
              render={({ field }) => (
                <Select
                  {...field}
                  ref={selectRef}
                  autoFocus
                  className={`react-selectcomponent form-control ${errors?.admin_id ? 'error-input' : ''}`}
                  getOptionLabel={(option) => `${option.first_name} ${option.last_name} (${option.email})`}
                  getOptionValue={(option) => `${option.admin_id}`}
                  options={allAdmin?.admins || []}
                  isSearchable={true}
                  isClearable
                  placeholder={`Select Admin`}
                  classNamePrefix="select_kanakku"
                />
              )}
            />
            <small>{errors?.admin_id?.admin_id?.message || errors?.admin_id?.message}</small>
          </div>
        </div>
        {/* <div className="col-lg-12 col-sm-12">
          <div className="form-group input_text">
            <label>
              Region
              <span className="text-danger"> *</span>
            </label>
            <Controller
              name="regions"
              control={control}
              render={({ field }) => (
                <Select
                  {...field}
                  className={`react-selectcomponent form-control ${errors?.regions ? 'error-input' : ''}`}
                  getOptionLabel={(option) => option.region || ''}
                  getOptionValue={(option) => option.region_id || ''}
                  options={allRegion || []}
                  isSearchable={true}
                  isClearable
                  isMulti
                  placeholder="Select Region"
                  classNamePrefix="select_kanakku"
                  onChange={(selectedOptions) => {
                    // Map the selected options to an array of region IDs
                    const selectedRegionIds = selectedOptions.map((option) => option.region_id)
                    field.onChange(selectedRegionIds) // Update the field value with the array of IDs
                  }}
                  // You can handle the default value if needed
                  value={allRegion.filter((region) => field?.value?.includes(region.region_id))} // Match selected IDs to the full region objects
                />
              )}
            />
            <small className="text-danger">{errors?.regions?.message}</small>
          </div>
        </div> */}
      </div>
      <div className="row">
        <div className="col-lg-12 col-sm-12">
          <div className="form-group input_text">
            <label>
              Region <span className="text-danger"> *</span>
            </label>
            <Controller
              name="region"
              control={control}
              render={({ field }) => (
                <Select
                  {...field}
                  className={`react-selectcomponent form-control ${errors?.region?.region_id ? 'error-input' : ''}`}
                  getOptionLabel={(option) => `${option.region}`}
                  getOptionValue={(option) => `${option.region_id}`}
                  options={allRegion || []}
                  isClearable
                  isSearchable={true}
                  placeholder={`Select Region`}
                  classNamePrefix="select_kanakku"
                  // defaultValue={defaultRegion ? { region_id: defaultRegion.region_id, region: defaultRegion.region } : null}
                />
              )}
            />
            <small>{errors?.region?.region_id?.message || errors?.region?.message}</small>
          </div>
        </div>
      </div>
      <div className="multi_btn_div">
        <button type="button" className="btn common-outline-btn w-100" onClick={() => toggle()}>
          Cancel
        </button>
        <button type="submit" className="btn btn-primary common-field-btn w-100">
          {`Save`}
        </button>
      </div>
    </form>
  )
}

export default NewRegionAdmin
